export default __webpack_public_path__ + "static/Step-5-84612cad20ff303bcd3bc0e135adda05.svg";